(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    

const testimonialSwiper = () => {
  new Swiper('.testimonial-section__content', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 22,
      },
    }
  });
};

const matchVideoCardHeight = () => {
  const textCards = document.querySelectorAll(
    '.testimonial-review__wrapper:not(.testimonial-review__wrapper--video)'
  );
  const videoCards = document.querySelectorAll('.testimonial-review__wrapper--video');

  if (!textCards.length || !videoCards.length) return;

  videoCards.forEach((card) => {
    card.style.height = '';
    card.style.maxHeight = '';
  });

  const allSlides = document.querySelectorAll('.testimonial-section__content .swiper-slide');

  allSlides.forEach((slide) => {
    slide.style.display = 'flex';
    slide.style.visibility = 'hidden';
    slide.style.position = 'absolute';
  });

  let maxHeight = 0;
  textCards.forEach((card) => {
    const h = card.offsetHeight;
    if (h > maxHeight) maxHeight = h;
  });

  allSlides.forEach((slide) => {
    slide.style.display = '';
    slide.style.visibility = '';
    slide.style.position = '';
  });

  if (maxHeight === 0) return;

  videoCards.forEach((card) => {
    card.style.height = maxHeight + 'px';
    card.style.maxHeight = maxHeight + 'px';
    card.style.overflow = 'hidden';
  });
};

const initVideoModals = () => {

  document.querySelectorAll('.testimonial-video__modal').forEach((modal) => {
    document.body.appendChild(modal);
    modal.style.display = 'none';
  });

  document.querySelectorAll('[data-video-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const id = trigger.getAttribute('data-video-trigger');
      const modal = document.getElementById('video-modal-' + id);
      if (!modal) return;
      openModal(modal);
    });
  });

  document.addEventListener('click', (e) => {
    const closeTarget = e.target.closest('[data-modal-id]');
    if (!closeTarget) return;
    const id = closeTarget.getAttribute('data-modal-id');
    const modal = document.getElementById('video-modal-' + id);
    if (!modal) return;
    closeModal(modal);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.testimonial-video__modal.is-open').forEach(closeModal);
  });

  function openModal(modal) {
    modal.style.cssText = [
      'display: flex',
      'position: fixed',
      'top: 0',
      'left: 0',
      'width: 100vw',
      'height: 100vh',
      'height: 100dvh',
      'z-index: 2147483647',
      'align-items: center',
      'justify-content: center',
      'padding: 0',
      'margin: 0',
    ].join(' !important;') + ' !important;';

    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    const box = modal.querySelector('.testimonial-video__modal-box');
    if (box) {
      box.style.cssText = [
        'position: relative',
        'margin: auto',
        'left: auto',
        'right: auto',
        'top: auto',
        'bottom: auto',
        'transform: none',
        'width: min(92vw, 520px)',
      ].join(' !important;') + ' !important;';
    }

    const video = modal.querySelector('video');
    if (video) video.play().catch(() => {});
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    modal.style.display = 'none';
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';

    const video = modal.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }

}; // ← initVideoModals closes here

// ── Single DOMContentLoaded ──
document.addEventListener('DOMContentLoaded', () => {
  testimonialSwiper();
  initVideoModals();

  window.addEventListener('load', () => {
    setTimeout(matchVideoCardHeight, 200);
  });

  setTimeout(matchVideoCardHeight, 500);

  window.addEventListener('resize', matchVideoCardHeight);
});


  } catch(e) { console.error(e); }
})();
})();
